import { UpdateGroupTitleScreenNavigationProps } from "./types"
import React from "react"
import UpdateGroupTitle from "./update-group-title-screen"
import { PageRoot } from "~screens/page-root"


const UpdateGroupTitleScreen: React.FC<UpdateGroupTitleScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <UpdateGroupTitle />
    </PageRoot>
  )
}

export default UpdateGroupTitleScreen
